import React from "react";
import classNames from "classnames";

import { useAdjustWorkload } from "@planzone/view-models";
import { computeNaturalPeriodBounds } from "../../../utils";
import { NumberInput } from "./numberInput";
import { Props } from "./types";
import styles from "./styles.scss";

function Cell(props: Props) {
  const { from, to } = computeNaturalPeriodBounds(
    props.period.from,
    props.granularity,
  );
  const { isRequestPending, isRequestFailure, adjustWorkload } =
    useAdjustWorkload(
      props.resourceId,
      props.projectId,
      from,
      to,
      props.granularity,
    );
  const [load, setLoad] = React.useState(props.period.load);

  React.useEffect(() => {
    setLoad(props.period.load);
  }, [props.period.load]);

  return (
    <div
      className={classNames(styles.cell, {
        [styles.failed]: isRequestFailure,
      })}
    >
      {props.canEdit ? (
        <NumberInput
          nbr={load}
          isDisabled={isRequestPending}
          edit={(nbr) => setLoad(nbr < 0 ? 0 : nbr)}
          submit={(value) =>
            !isRequestPending &&
            adjustWorkload({
              resourceId: props.resourceId,
              projectId: props.projectId,
              from,
              to,
              granularity: props.granularity,
              value,
            })
          }
        />
      ) : (
        <p className={styles.value}>{load.toLocaleString(props.locale)}</p>
      )}
    </div>
  );
}

export { Cell };
